// Questions shown in the FAQ accordion. Line breaks (\n) in answers are preserved.
export const faqs = [
  {
    question: "What educational approach does Agape Garden follow?",
    answer: "At Agape Garden, we follow a structured and child-centered curriculum designed to foster holistic development.\n\nPlaygroup & Pre-KG: Montessori Method and activity based learning\nLKG & UKG: CBSE Curriculum"
  },
  {
    question: "What age group does Agape Garden cater to?",
    answer: "Agape Garden offers programs for children between 2 to 6 years, categorized as follows:\n\nPlaygroup: 2 – 3 years\nPre-KG: 3 – 4 years\nLKG: 4 – 5 years\nUKG: 5 – 6 years"
  },
  {
    question: "How are teachers selected and trained at Agape Garden?",
    answer: "Our teachers are carefully selected based on their Montessori qualifications and passion for early childhood education.\nThey undergo regular training to ensure high-quality, nurturing, and engaging learning experiences for every child."
  },
  {
    question: "What sets Agape Garden apart from other preschools?",
    answer: "At Agape Garden, we emphasize practical learning that helps children develop real-world understanding and essential life skills, preparing them for future academic success."
  }
];
